var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIndustry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.76 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_13);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .85;\n      }\n\n      .cls-2 {\n        fill: url(#Naamloos_verloop_48);\n      }\n\n      .cls-3 {\n        fill: url(#Naamloos_verloop_13-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_13",
    "data-name": "Naamloos verloop 13",
    x1: 33.85,
    y1: 20.82,
    x2: 44.91,
    y2: 20.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_13-2",
    "data-name": "Naamloos verloop 13",
    x1: 14.67,
    y1: 23.6,
    x2: 25.18,
    y2: 23.56,
    xlinkHref: "#Naamloos_verloop_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_48",
    "data-name": "Naamloos verloop 48",
    x1: 68.39,
    y1: 29.03,
    x2: -6.05,
    y2: 55.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ede9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eedee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#efccd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1b2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f491a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f8697f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fc3a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.31,24.02c.46-.27,1,.12,1,.72l-.06,8.6c0,.59.54.98,1,.72l5.03-2.89-1.25-21.92c-.06-.99-.91-1.77-1.95-1.77h-5.73c-1.04,0-1.89.78-1.95,1.77l-1.01,17.62,4.93-2.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.94,23.96c.46-.26,1,.12,1,.71v8.67c0,.59.54.97,1,.71l4.59-2.65-.98-16.64c-.06-.97-.91-1.73-1.95-1.73h-5.73c-1.04,0-1.89.76-1.95,1.73l-.7,11.9,4.72-2.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.74,24.72s0,30.28,0,30.51H.02c0-.18,0-19.95,0-19.95,0-.3.15-.58.38-.71l18.54-10.6c.46-.26,1,.12,1,.71v8.67c0,.59.54.97,1,.71l17.38-10.03c.46-.27,1,.12,1,.72l-.06,8.6c0,.59.54.98,1,.72l17.49-10.04c.46-.26,1,.12,1,.71Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustry);
export default __webpack_public_path__ + "static/media/icon_industry.885035180fa14b7ea84361bd6e7c9b21.svg";
export { ForwardRef as ReactComponent };